export const CLOJARS_REPO = 'https://clojars.org/repo';
